@if (item) {
  <div class="stitch-list-item with-bar" [class.selected]="selected && !isDragging" [class.hovered]="contextMenuOpened"
    [appFormContextMenu]="item" (appFormContextMenuOpen)="open.emit()"
    appDraggable [appDraggableData]="dragData" [appDraggableDisabled]="!dragEnabled" [appDraggablePlaceholder]="dragPlaceholder"
    (appDraggableDraggingChanged)="isDragging = $event"
    appDroppable [appDroppableDisabled]="!dragEnabled || item.deleted" appDroppableHoverClass="drag-over"
    [appDroppablePredicate]="dndPredicate" (appDroppableDrop)="dndDrop($event)"
    (appClick)="onClick.emit(item)" (appDblClick)="onDoubleClick.emit(item)">
    <div class="stitch-list-item-body">
      <div class="stitch-list-item-body-header">
        <div class="stitch-list-item-body-title"><div class="stitch-list-item-body-title-text" [class.blank]="!item.title">{{ item.title || 'Untitled form' }}</div></div>
        <div class="stitch-list-item-hover-actions" [appClickStopPropagation]="true">
          <stch-quick-action icon="sapphire-archive2" [active]="item.archived" (onClick)="archive()" [matTooltip]="item.archived ? Labels.RestoreFromArchive : Labels.Archive" />
          <stch-trash-action [deleted]="item.deleted" (onClick)="delete()" />
        </div>
      </div>
      <div class="stitch-list-item-body-item inline">Created: {{ item.createdAt | dateFormat: 'relativeDate' }}
        <div class="stitch-list-item-body-item-separator"></div>Updated: {{ item.updatedAt | dateFormat: 'relativeDate' }}</div>
      <div class="stitch-list-item-body-item truncate">{{ item.responseCount }} {{ item.responseCount === 1 ? 'response' : 'responses' }} | {{ item.accepting ? 'Collecting' : item.publishedVersion ? 'Closed' : 'Draft' }}</div>
      <stch-bottom-bar [stitchItem]="item" [showNested]="false" [showChild]="false" (expand)="barExpanded = $event" (pinClick)="pin($event)" (flagClick)="flag($event)" />
    </div>
    <div class="drop-zone"></div>
  </div>
}

<ng-template #dragPlaceholder>
  <app-forms-library-card [item]="item" [dragEnabled]="false" />
</ng-template>
